import RegisterWithDetailsStepDetailsForm from './form';

export default function RegisterWithDetailsStepDetails() {
  return <RegisterWithDetailsStepDetailsForm />;
}
